
import axios from 'axios'
import { useOAuthStore } from '@/stores/oauth'
import { useUserInfoStore } from "@/stores/userInfo";
import {API_URL} from "@/interface/globalindex"
import router from '@/routes';


const axiosInstance = axios.create({
  baseURL: API_URL, // 根据你的 API 地址设置 baseURL
  timeout: 90000, // 设置请求超时（根据需要修改）
  withCredentials:true,
})

// 请求拦截器：在请求发送前加入 Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    const authStore = useOAuthStore()
    const token = authStore.token

    if (token) {
      // 如果 token 存在，添加 Authorization header
      if (config.headers) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    const userInfoStore = useUserInfoStore();
    const authStore = useOAuthStore();
    
    if (response) {
      switch (response.status) {
        case 401:
          // 清除 token 和用户信息
          authStore.clearToken();
          userInfoStore.clearUser();
          // 跳转到首页
          router.push('/');
          break;
        case 403:
          // 跳转到登录页并提示
          router.push('/');
          break;
        // case 500:
        //   router.push('/');
        //   break;
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance